export default "<p>deleted-emails works!</p>\n";